module.exports = __webpack_public_path__ + "img/Z85-X18-中_11.e86e2ac0.jpg";